<template>
  <div class="cenList">
	  <div class="cenListForTile" >
	  	配套产品
	  </div>
	  <div class="cenListForCen">
	  	<div class="cenListForCenFor" v-for="(item,index) in list" :key="index">
	  		<div class="cenListForCenForImg">
	  			<img :src="item.img">
	  		</div>
	  		<div class="cenListForCenForName">
	  			{{item.name}}
	  		</div>
	  	</div>
	  </div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		list:[
			{
				img:require("@/assets/product/page6/axb.png"),
				name:'FHD'
			},
			{
				img:require("@/assets/product/page6/axb.png"),
				name:'FHD'
			},
			{
				img:require("@/assets/product/page6/axb.png"),
				name:'澳小宝'
			},
		]
      }
    },
    mounted() {

    },
    methods: {
		goDetail(){
			this.$router.push({
				path:'/productDetail',
				name:'productDetail',
				query:{
					id:1
				}
			})
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.cenList{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.cenListForTile{
		font-size: 45px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 73px;
	}
	.cenListForCen{
		display: flex;
		flex-wrap: wrap;
		.cenListForCenFor:hover{
			.cenListForCenForImg{
				img{
					transform: scale(1.1);
				}
			}
		}
		.cenListForCenFor:nth-of-type(3n-1){
			margin: 0 2%;
		}
		.cenListForCenFor{
			width: 32%;
			margin-bottom: 30px;
			.cenListForCenForImg{
				overflow: hidden;
				width: 100%;
				height: 260px;
				img{
					width: 100%;
					object-fit: contain;
					transition: all 0.3s ease-in-out;
				}
			}
			.cenListForCenForName{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
				margin:32px 0px;
				text-align: center;
				overflow : hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
}
</style>
